import { all, takeEvery } from 'redux-saga/effects';
import { fetchMarginOptionsAction } from '../actions';
import { fetchMarginOptionsSaga } from './fetchMarginOptionsSaga';

export function* marginOptionsSagaWatcher() {
  yield all([takeEvery(fetchMarginOptionsAction.TYPE, fetchMarginOptionsSaga)]);
}
